












































import {
  Component, Prop, VModel, Watch,
} from 'vue-property-decorator';
import { CustomerData } from '@/store/customers/types';
import { OrganizationData } from '@/store/organizations/types';
import { isRedzoneOrganizationGuid } from '@/common/utils/ConstantsUtils';
import AdminPanelMixin from '../AdminPanelMixin.vue';
import CustomerEditDialog from './CustomerEditDialog.vue';

@Component({
  components: {
    CustomerEditDialog,
  },
})
export default class CustomerDialogMultiSelectCustomer extends AdminPanelMixin {
  @VModel() modelValue!: CustomerData[] | undefined;

  @Prop({ default: null }) organization: OrganizationData | undefined;

  @Prop({ default: false }) requireOrganization: boolean | undefined;

  @Prop({ default: false }) hasPermissionCreateACustomer: boolean | undefined;

  @Prop({ default: true }) hideDetails: boolean | undefined;

  showNewCustomerDialog = false;

  customerValues = [];

  customerNameSearch = null;

  currentEditItem = {};

  valid = false as boolean;

  async mounted(): Promise<void> {
    if (!this.customerDataList) {
      await this.fetchCustomerData();
    }
    if (this.modelValue) {
      this.setLocalValues();
    }
  }

  @Watch('modelValue')
  onModelValueChange(): void {
    this.setLocalValues();
  }

  @Watch('organization')
  onOrganizationChange(): void {
    if (this.requireOrganization && this.modelValue) {
      // If the required organization is changed
      // and it does not match the organization guid of modelValue
      // then reset to make sure the customer's organization matches the intended organization
      this.modelValue.filter((cust) => this.organization.guid === cust.guid);
    }
  }

  /**
   * @description Sets all local values from the modelValue.
   */
  setLocalValues(): void {
    this.customerValues = this.modelValue.map((cust) => cust.name);
    this.customerNameSearch = '';
  }

  @Watch('showNewCustomerDialog')
  onShowNewCustomerDialogChange(): void {
    if (!this.showNewCustomerDialog) {
      // If closing the dialog, then reset the search
      this.setLocalValues();
      this.currentEditItem = {};
    }
  }

  /**
   * @description Checks for a new user in the combobox
   * @remarks If an existing user is selected, then select them. If not, then open up the popup
   */
  checkforNewUserAdd(): void {
    const foundValues = this.customerValues
      .map((customerValue: string) => this.customersList.find((u) => u.name === customerValue));

    const missingIndex = foundValues.findIndex((x) => !x);
    if (missingIndex === -1) {
      this.modelValue = foundValues;
    }
  }

  /**
   * @description Sets modelValue to value of newCustomer and sets local values
   * @param {CustomerData} newCustomer
   */
  updateLocalCustomer(newCustomer: CustomerData): void {
    this.modelValue.push(newCustomer);
    this.setLocalValues();
  }

  /**
   * @description Get a list of all customer strings
   * @returns {CustomerData[]} list of customer names
   */
  get customersList(): CustomerData[] {
    if (!this.customerDataList) {
      return [];
    }
    if (this.requireOrganization) {
      if (!this.organization) {
        return [];
      }
      if (isRedzoneOrganizationGuid(this.organization?.guid)) {
        return [...this.customerDataList];
      }
      return this.customerDataList
        .filter((cust) => this.organization?.guid === cust.organizationGuid);
    }
    return [...this.customerDataList];
  }

  get customersStringList(): string[] {
    return this.customersList.map((cust) => cust.name);
  }

  /**
   * @description On pressing enter, open up new org dialog if the search is not a valid item
   */
  createNewOrganization(): void {
    const foundValues = this.customerValues
      .map((customerValue: string) => this.customersList.find((u) => u.name === customerValue));
    const missingIndex = foundValues.findIndex((x) => !x);
    if (missingIndex !== -1) {
      this.currentEditItem = {
        customerName: this.customerValues[missingIndex],
        address: '',
        systemOwner: null,
        email: '',
        phoneNumber: null,
        organization: null,
      };
      this.showNewCustomerDialog = true;
      (this.$refs.customerValuesComboBox as any).isFocused = false;
    }
  }

  /**
   * @description when leaving focus, make sure the search is a valid value
   */
  onBlur(): void {
    this.customerNameSearch = '';
  }
}
